import {useEffect, useState} from "react";
import "./Avatar.scss"
import classNames from "classnames";
import applicationConfiguration from "../../config/applicationConfiguration";

const Avatar = ({ name, surname, url, color, onClick, className }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const initials = `${name?.[0] ?? ''} ${surname?.[0] ?? ''}`

    useEffect(() => {
        if(url){
            setImageUrl(`${applicationConfiguration.apiUrl}/api/avatars/${url}`)
        }
    }, [url]);

    return (
        <div
            onClick={onClick}
            className={classNames("wrapper", { "clickable": onClick }, className)}
        >
            {
                imageUrl ?
                    <img src={imageUrl} className="profile" alt="Profile" />
                    :
                    <span className={classNames("profile", { "color": !color })} style={color ? { backgroundColor: color } : {}}>
                        {initials}
                    </span>
            }
        </div>
    );
};

export default Avatar;